/**
 * impersonationSession.ts — the CUSTOMER-SIDE slice of the support-session API.
 *
 * The ImpersonationBanner (mounted in the customer app's RootLayout) polls the
 * active session for the countdown and can exit it. Those two calls live here,
 * separate from the OPERATOR-only enter/list functions in supportSession.ts, so
 * the customer bundle never ships the impersonation-START or org-listing code —
 * those belong to the operator SPA. All endpoints stay is_global-gated server-side.
 */
import { apiClient } from './client';

export interface ActiveSupportSession {
  active: true;
  sessionId: string;
  targetOrganization: { id: string; name: string };
  enteredAt: string;
  expiresAt: string;
  reason: string;
}

export interface InactiveSupportSession {
  active: false;
}

export type SupportSessionStatus = ActiveSupportSession | InactiveSupportSession;

/** GET /admin/support-session/active — drives the banner countdown. */
export async function getActiveSupportSession(): Promise<SupportSessionStatus> {
  const res = await apiClient.get('/admin/support-session/active');
  return (res.data?.data ?? res.data) as SupportSessionStatus;
}

/** POST /admin/support-session/exit — end current session and return to home org. */
export async function exitSupportSession(): Promise<void> {
  await apiClient.post('/admin/support-session/exit');
}
